import { SceneNames } from '@Core/SceneNames';

export type TPreloaderState = {
    currentScene: SceneNames | undefined;
    showIntroMovie: boolean;
    showPreloaderInfo: boolean;
    loaderState: string | undefined;
};

export const RC_PRELOADER_DEFAULTS = {
    currentScene: undefined,
    showIntroMovie: true,
    showPreloaderInfo: true,
    loaderState: undefined
};

export type TAssetsLoaderState = {
    progress: number;
    assetType: string;
    assetKey: string;
    loaderState: string;
};

export const RC_PROGRESS_BAR_DEFAULTS = {
    progress: 0,
    assetType: '',
    assetKey: '',
    loaderState: 'START'
};
